import React, { Dispatch, useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Snackbar from "../../common/components/CreatedEnquirySnackbar";
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import moment from "moment-timezone";
import NotificationIcon from "../../common/components/NotificationIcon";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory } from "react-router-dom";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import DatePicker from "../../common/components/dateRangePicker";
import viewReturnIcon from "../../assets/viewReturnIcon.png";
import { withStyles } from "@material-ui/core/styles";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  Menu,
  MenuProps,
  Select,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import { getListOfReturnItems } from "../../store/actions/delivery.actions";
import _, { get } from "lodash";
import { viewReturnOrderAPI, viewRetrunOrderForm } from "../../store/actions/delivery.actions";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { getFSECustomerList } from "../../store/actions/dealer.action";
import { getCustomerFilterOptions } from "../../common/components/util";
import InfoIcon from '@material-ui/icons/Info';
import VisibilityIcon from '@material-ui/icons/Visibility';
import StatusStepperPopover from "./StatusStepperPopover";

const SHOW_RETURN_FORM_STATUSES = ["Quality check pending", "Approved", "Partially Approved"];

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  actionButtons: {
    display: "flex",
    gap: 16,
    marginTop: 24,
    marginBottom: 24,
  },
  actionButton: {
    color: "#1A9FE0",
    marginBottom: "2px"
  },
  invoiceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  invoiceInfo: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
  },
  pageSub: {
    fontWeight: 800,
    color: "#000000",
    fontSize: "0.875rem",
    margin: 0,
  },
  invoiceId: {
    fontSize: "1.125rem",
    fontWeight: 700,
    fontFamily: "Nunito",
    color: "#1a1a1a",
    margin: 0,
  },
  invoiceDate: {
    fontSize: "0.875rem",
    fontFamily: "Nunito",
    color: "#666666",
    margin: 0,
    paddingTop: 6,
  },
  headerActions: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    justifyContent: "flex-end",
  },
  checkboxFix: {
    paddingLeft: "8px",
    display: "inline-flex",
    alignItems: "center",
    fontFamily: "Nunito",
    whiteSpace: "nowrap",
    fontWeight: 600,
    fontSize: "0.813rem",
    color: "#444444",
  },
  tableContainer: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  tableHeader: {
    backgroundColor: "#ffffff",
  },
  headerCellName: {
    color: "#133F8A",
    fontWeight: 900,
    fontSize: "0.75rem",
    textAlign: "left",
    fontFamily: "Nunito",
    borderBottom: "2px solid #e0e0e0",
    padding: "16px",
    whiteSpace: "nowrap",
  },
  headerCell: {
    color: "#133F8A",
    fontWeight: 900,
    fontSize: "0.75rem",
    textAlign: "center",
    fontFamily: "Nunito",
    borderBottom: "2px solid #e0e0e0",
    padding: "16px",
    whiteSpace: "nowrap",
  },
  bodyCell: {
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  bodyCell1: {
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  subHeaderText: {
    fontSize: "0.75rem",
    fontFamily: "Nunito",
    fontWeight: 600,
    color: "#161212ff",
    marginTop: 4,
  },
  iframeContainer: {
    width: "100%",
    height: "70vh",
    border: "none",
    backgroundColor: "#fff",
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

interface Payload {
  sapCustomerId: string,
  userId: string;
  userRole: string;
  salesChannel?: string;
  referenceNumbers?: string;
  status?: string;
  toDate?: string;
  fromDate?: string;
  requestedByMe?: boolean;
  skip: number;
  limit: number;
}

export default function SalesReturnRequest() {
  const classes = useStyles();
  const history = useHistory();
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;
  const dispatch: Dispatch<any> = useDispatch();
  const [loading, setLoading] = React.useState<any>(false);
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [returnOrderList, setReturnOrderList] = useState<any[]>([]);
  const [count, setCount] = useState<number>(0);
  const [searchText, setsearchText] = useState<any>("");
  const [status, setstatus] = useState<any>("");
  const [isMyReturns, setIsMyReturns] = useState<boolean>(false);
  const [etag, setEtag] = React.useState<any>("");
  const [openPdfViewer, setOpenPdfViewer] = useState<boolean>(false);
  const { getFSECustomerListData }: any = useSelector((state: any) => state.dealer);
  const { returnOrder, viewReturnOrderAPIDetails, viewReturnOrderFormAPI }: any = useSelector((state: any) => state.delivery);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const today = moment(new Date());
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [viewDownloadRetrunOrderForm, setViewDownloadRetrunOrderForm] = React.useState("");
  const [htmlContent, setHtmlContent] = React.useState<string>("");
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [customerId, setCustomerId] = React.useState<any>([]);
  const [selectedCustomerId, setSelectedCustomerId] = React.useState<any>('');
  const [selectedCustomerName, setSelectedCustomerName] = React.useState<any>('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedTrackingStatus, setSelectedTrackingStatus] = useState<any[]>([]);
  const [searchTextByID, setSearchTextByID] = React.useState<any>('');
  const [filterByCustomer, setFilterByCustomer] = React.useState(sessionStorage.getItem('userType') === 'sre' ? "All" : '')
  const [allCustomers, setAllCustomers] = React.useState<any[]>([]);

  React.useEffect(() => {
    setAllCustomers(getFSECustomerListData && getFSECustomerListData.data)
    setCustomerId(getFSECustomerListData && getFSECustomerListData.data);
  }, [getFSECustomerListData]);

  React.useEffect(() => {
    if (!filterByCustomer || filterByCustomer === 'All') {
      setCustomerId(allCustomers);
      return;
    }
    if (!allCustomers || allCustomers.length === 0) return;

    const map: any = {
      Dealer: 'dealer',
      Workshop: 'workshop',
      Government: 'government',
      Fleet: 'fleet',
      'TPC Dealer': 'tpcdealer',
      'TBL Dealer': 'tbl dealer',
      'Int. Business': 'int. business',
    };

    const selectedType = map[filterByCustomer || 'Dealer'];

    const filtered = allCustomers.filter(
      item => item.customerTierType?.toLowerCase() === selectedType
    );

    setCustomerId(filtered);
  }, [filterByCustomer, allCustomers]);

  const b2bUserId = _.get(profileDetails, "data.data.basicInfo.b2bUserId", "");

  // Formatted the customerTierType values
  const formatCustomerTier = (value: string | null) => {
    if (!value) return "";
    const trimmed = value.trim();
    const exactValues: Record<string, string> = {
      "tpc dealer": "tpcdealer",
      "tpcdealer": "tpcdealer",
      "int. business": "Int. Business",
      "int.business": "Int. Business",
      "tbl dealer": "TBL Dealer",
      "tbldealer": "TBL Dealer",
      "TBL Dealer": "TBL Dealer",
    };

    if (exactValues[value]) {
      return exactValues[value];
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };

  const handleViewRetrunOrderForm = async (orderNumber?: any, invoiceNumber?: any, sapCustomerId?: any, invoiceDate?: any, returnDate?: any) => {
    setLoading(true);
    const payload = {
      "invoiceNumber": invoiceNumber,
      "sapCustomerId": sapCustomerId,
      "orderNumber": orderNumber,
      "returnDate": returnDate,
      "invoiceDate": invoiceDate
    };

    let responseData: any = await dispatch(viewRetrunOrderForm(payload));

    if (responseData && responseData.status === 400) {
      setOpenErrorSnackbar(true);
      handleopenCloseErrorSnackbar(true);
      setShowErrorMessage(responseData?.error);
      setLoading(false);
    } else {
      // Parse the deeply nested HTML string
      let htmlString = "";

      try {
        // The response structure is: responseData.data.data contains a quoted HTML string
        if (responseData?.data?.data) {
          // Remove outer quotes and parse the JSON string
          htmlString = JSON.parse(responseData.data.data);
        } else {
          throw new Error("Invalid response structure");
        }

        setHtmlContent(htmlString);
        setOpenErrorSnackbar(false);
        handleopenCloseSnackbar(true);
        setSuccessMessage(responseData?.message?.message || "Return form loaded successfully");

      } catch (e) {
        console.error("Error parsing HTML:", e);
        setOpenErrorSnackbar(true);
        handleopenCloseErrorSnackbar(true);
        setShowErrorMessage("Failed to load return order form. Please try again.");
        setHtmlContent(""); // Clear any partial content
      }

      setLoading(false);
    }
  };

  // Convert Date object to moment object
  const momentDate = moment(thirtyDaysAgo);

  // Format the date with day, month, year, hours, minutes, seconds, and timezone
  let formattedDate: any = momentDate.format("ddd MMM DD YYYY HH:mm:ss");
  formattedDate = moment(new Date(formattedDate));

  const [startDate, setstartDate] = useState<any>(formattedDate);
  const [endDate, setendDate] = useState<any>(today);
  const statusOptions = [
    "All",
    "Submitted",
    "In Progress",
    "Quality check pending",
    "Approved",
    "Not Approved",
    "Partially Approved",
  ];

  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const sapCustomerId = _.get(
    profileDetails,
    "data.data.basicInfo.sapCustomerId",
    ""
  );
  const userRole: any = sessionStorage.getItem('userType');

  const resetFilters = () => {
    setsearchText('');
    setPage(0);
    setstartDate(formattedDate);
    setendDate(today);
    setstatus("");
    setSelectedCustomerId('');
    setSelectedCustomerName('');
    setFilterByCustomer(sessionStorage.getItem('userType') === 'sre' ? "All" : '')
    setSearchTextByID('')
    setIsMyReturns(false);
    fetchReturnOrderAPI(0, true, false, "All");
  }

  const handleClose = () => {
    setAnchorEl(null);
    setSearchTextByID("");
  };

  const fetchReturnOrderAPI = async (pageNumber: number = page, isReset: boolean = false, isMyReturnsValue?: boolean, defaultfilterByCustomer?: string) => {
    setLoading(true);
    const payload: Payload = {
      sapCustomerId:
        userRole.toLowerCase() === 'sre'
          ? ''
          : (isReset ? '' : selectedCustomerId),
      userId: userRole === 'FSE' || userRole.toLowerCase() === 'sre' ? webApplicationLoginId : b2bUserId,
      userRole: userRole === 'FSE' || userRole.toLowerCase() === 'sre' ? userRole.toUpperCase() : "Admin",
      skip: pageNumber * rowsPerPage,
      limit: rowsPerPage,
    };

    const updatedCustomerTierType = formatCustomerTier(filterByCustomer?.toLowerCase() || "");

    if (sessionStorage.getItem('userType') === 'sre') {
      payload.salesChannel = defaultfilterByCustomer || updatedCustomerTierType
    }

    if (!isReset) {
      if (searchText != "") {
        payload.referenceNumbers = searchText;
      }

      if (status != "") {
        payload.status = status;
      }

      if (startDate) {
        payload.fromDate = startDate;
      }

      if (endDate) {
        payload.toDate = endDate;
      }

      if (userRole === 'sre') {
        payload.salesChannel = updatedCustomerTierType
        payload.sapCustomerId = selectedCustomerId
      }
    }
    if ((isMyReturnsValue !== undefined ? isMyReturnsValue : isMyReturns) && (userRole == 'FSE' || userRole === 'sre')) {
      payload.requestedByMe = true;
    }

    let responseData: any = await dispatch(getListOfReturnItems(payload));
    let returnOrderResponse = [];

    if (responseData && responseData.status === 400) {
      setOpenErrorSnackbar(true);
      handleopenCloseErrorSnackbar(true);
      setShowErrorMessage(responseData?.error);
    } else {
      if (responseData?.data?.returnOrders) {
        returnOrderResponse = (responseData.data.returnOrders);
      }
      setOpenErrorSnackbar(false);
      // handleopenCloseSnackbar(true);
      // setSuccessMessage(
      //   responseData && responseData.message && responseData.message.message
      // );
    }
    setReturnOrderList(returnOrderResponse);
    if (payload.skip == 0) {
      setCount(responseData?.data?.totalCount ?? 0);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (userRole == "FSE" || sessionStorage.getItem('userType') === 'sre') {
      if (getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0) {
      } else {
        dispatch(getFSECustomerList());
      }
    }
    // Call the action on component mount
    fetchReturnOrderAPI();
  }, []);

  const getInvoiceColor = (status: string): string => {
    switch (status) {
      case "Less than 7 days":
        return "#E88B00";
      case "7 to 15 days":
        return "#1A9FE0";
      case "15 days & above":
        return "black";
      default:
        return "black";
    }
  };

  const getStatusColor = (status: string): string => {
    switch (status) {
      case "Submitted":
        return "#30BD4C";
      case "Quality check pending":
        return "#0F336E";
      case "Approved":
        return "#30BD4C";
      case "Not approved":
        return "#FF0000";
      case "In progress":
        return "#1A9FE0";
      case "Partially approved":
        return "#E88B00";
      default:
        return "black";
    }
  };

  const ViewReturnOrderRequest = async (rowSapCustomerId?: any, rowInvoiceNumber?: any, rowOrderNumber?: any) => {
    setLoading(true);
    const payload = {
      invoiceNumber: rowInvoiceNumber,
      orderNumber: rowOrderNumber,
      sapCustomerId: rowSapCustomerId,
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      },
      role: sessionStorage.getItem('userType-Profile-API')
    };

    let responseData: any = await dispatch(viewReturnOrderAPI(payload));
    if (responseData && responseData.status === 400) {
      setOpenErrorSnackbar(true);
      handleopenCloseErrorSnackbar(true);
      setShowErrorMessage(typeof responseData?.error === 'string' ? responseData?.error : 'Unable to get return order');
      setLoading(false);
    } else {
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(true);
      setSuccessMessage(
        responseData && responseData.message && responseData.message.message
      );
      setLoading(false);
      history.push(`/returnrequestdetails`);
    }
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage((prevPage) => {
      const updatedPage = newPage;
      return updatedPage;
    });
    fetchReturnOrderAPI(newPage, false);
  };

  const handleClickPdfViewer = () => {
    setOpenPdfViewer(true);
  }

  // Download function for return order popup - using browser print dialog
  const handleDownload = () => {
    if (!htmlContent) {
      setOpenErrorSnackbar(true);
      setShowErrorMessage('No content available to download');
      return;
    }

    try {
      // Create a blob from the HTML content
      const printWindow = window.open('', '_blank');

      if (printWindow) {
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        // Wait for images and content to load
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
          }, 250);
        };
      } else {
        setOpenErrorSnackbar(true);
        setShowErrorMessage('Please allow pop-ups to download the PDF');
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      setOpenErrorSnackbar(true);
      setShowErrorMessage('Failed to download PDF. Please try again.');
    }
  };

  const handleClickSapId = (event: any, sapId: any, name: any) => {
    setSelectedCustomerId(sapId);
    setSelectedCustomerName(name);
  };

  const onSearchCustomerId = (searchText: any) => {
    setSearchTextByID(searchText);
    setCustomerId(getFSECustomerListData && getFSECustomerListData.data);
    if (searchText.length > 0) {
      const filteredIds = getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0 && getFSECustomerListData.data.filter((sapId: any) => sapId.sapCustomerId.toLowerCase().includes(searchText.toLowerCase()) || sapId.name.toLowerCase().includes(searchText.toLowerCase()));
      setCustomerId(filteredIds);
    } else {
      setCustomerId(getFSECustomerListData && getFSECustomerListData.data);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className={classes.root}>
      {loading && <FullscreenLoader />}

      <Snackbar
        open={openSnackbar}
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseSnackbar(false);
        }}
      />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        message={showErrorMessage}
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false);
        }}
      />
      <div className="d-flex align-items-center mt-2 mb-2">
        <h2 className="page-title">Review Return Request</h2>
        <div className="ml-auto">
          <AnnouncementIcon />
          <NotificationIcon />
        </div>
      </div>
      {/* Filter Card */}
      {(userRole == "FSE" || userRole === 'sre') &&
        <div className="row mt-4">
          <div className="col-12">
            <div className="cardCommon p-3 pt-4" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <TextField
                  value={searchText}
                  onChange={(e) => {
                    setsearchText(e.target.value);
                  }}
                  size="small"
                  className="col-lg-4 common-input-font-size commonRoundedInputs searchField  p-[12px]"
                  label="Search by Invoice No/Return Order No."
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    style: { paddingRight: "6px" },
                  }}
                />
                <Tooltip
                  title="Maximum 31 days data can be tracked."
                  placement="top"
                >
                  <div className="col-4 d-inline-flex date-picker-50">
                    <DatePicker
                      startDate={startDate}
                      endDate={endDate}
                      setstartDate={setstartDate}
                      setendDate={setendDate}
                      isEnableOnlyThirtyDays={true}
                      onChange={(start: any, end: any) => {
                        setstartDate(start);
                        setendDate(end);
                      }}
                    />
                  </div>
                </Tooltip>

                <div
                  className={"col-3  d-inline-flex pl-0"}
                >
                  <FormControl
                    size="small"
                    variant="outlined"
                    className="rounded-input-dealer w-100"
                  >
                    <InputLabel id="status-label">Status</InputLabel>
                    <Select
                      labelId="status-label"
                      id="status"
                      value={status === "" ? "All" : status}
                      onChange={(e) => {
                        setstatus(e.target.value === "All" ? "" : e.target.value);
                      }}
                      label="Status"
                    >
                      {statusOptions.map((s) => (
                        <MenuItem key={s} value={s}>
                          {s}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <Button
                  className="col-1 font-size-11 pl-0 addOrderEnqButton"
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setPage(0);
                    fetchReturnOrderAPI(0, false);
                  }}
                >
                  Search
                </Button>
              </div>

              <div className="d-flex w-100 align-items-center">

                {sessionStorage.getItem("userType") === "sre" && (
                  <div className="col-4 d-inline-flex p-0">
                    <TextField
                      id="kamList"
                      select
                      label="Filter By CustomerType"
                      variant="outlined"
                      className="commonRoundedInputs w-100 bd-highlight mr-2 mb-2 mt-2"
                      size="small"
                      onChange={(e: any) => {
                        setSelectedCustomerId('');
                        setSelectedCustomerName('');
                        setFilterByCustomer(e.target.value);
                      }}
                      value={filterByCustomer}
                    >
                      {getCustomerFilterOptions('sreCustomerList')}
                    </TextField>
                  </div>)}

                <div
                  className={`p-0 d-inline-flex ${sessionStorage.getItem("userType") === "sre" ? "col-4" : "col-8"
                    }`}
                >
                  <TextField
                    id="customerId"
                    variant="outlined"
                    size="small"
                    onClick={handleClick}
                    value={selectedCustomerName}
                    label="Filter By Customer"
                    aria-controls="customized-menu"
                    className="commonRoundedInputs w-100"
                    aria-haspopup="true"
                    placeholder="Filter By Customer"
                    style={{ maxWidth: 400 }}
                  />
                  <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    className="dealer-custom-dropdown"
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <div>
                      <div className="mt-2">
                        <div className="searchDealer">
                          <IconButton
                            edge="start"
                            className="ml-2"
                            disabled
                          >
                            <SearchIcon fontSize="inherit" />
                          </IconButton>
                          <TextField
                            value={searchTextByID}
                            onChange={(e: any) => { onSearchCustomerId(e.target.value) }}
                            size="small"
                            className="ml-n2 mt-1"
                            placeholder="Search Customer(s)"
                            variant="outlined"
                          />
                        </div>
                      </div>
                      {customerId && customerId.length > 0 && customerId.map((sapId: any, i: any) => (
                        <Grid key={i} container className="border-bottom">
                          <MenuItem key={i} value={sapId.sapCustomerId}>
                            <ListItemText
                              primary={sapId.sapCustomerId}
                              onClick={(event: any) => {
                                handleClickSapId(event, sapId.sapCustomerId, sapId.name);
                                handleClose();
                              }}
                            />
                            <p className="px-5"
                              onClick={(event: any) => {
                                handleClickSapId(event, sapId.sapCustomerId, sapId.name);
                                handleClose();
                              }}
                            >
                              {sapId.name}
                            </p>
                          </MenuItem>
                        </Grid>
                      ))}
                      {customerId && customerId.length === 0 && (
                        <Grid container>
                          <div className="d-flex justify-content-center text-center mx-auto">No Customers found.</div>
                        </Grid>
                      )}
                    </div>
                  </StyledMenu>
                </div>

                <div className="col-4 d-flex justify-content-end p-0">
                  <Button
                    variant="contained"
                    className="cancel-button font-size-11 ms-auto"
                    onClick={resetFilters}
                  >
                    Reset Filters
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      {/* Return Order Header */}
      <div className={classes.invoiceHeader}>
        <div className={classes.invoiceInfo}>
          <h5 className={`${classes.pageSub} pt-2 pb-2`}>List of Sales Return Items</h5>
        </div>
      </div>

      {/* Table */}
      <div className={classes.tableContainer}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                {(userRole == "FSE" || userRole === 'sre') &&
                  <TableCell className={classes.headerCellName}>
                    Customer Name & SAP ID
                  </TableCell>
                }
                <TableCell className={classes.headerCell}>
                  Return Order No.
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Return Date & Time
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Return Request by
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Return Lines
                </TableCell>
                <TableCell className={classes.headerCell}>Invoice No.</TableCell>
                <TableCell className={classes.headerCell}>
                  <div className="mt-3 pt-0 pb-0">Invoice</div>
                  <div className={classes.subHeaderText}>Date</div>
                </TableCell>
                <TableCell className={classes.headerCell}>
                  <div className="mt-3 pt-0 pb-0">Invoice Gross value</div>
                  <div className={classes.subHeaderText}>(Incl. of VAT)</div>
                </TableCell>
                <TableCell className={classes.headerCell}>
                  <div className="mt-3 pt-0 pb-0">Total Return Value</div>
                  <div className={classes.subHeaderText}>(Excl. of VAT)</div>
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Invoice Period
                </TableCell>
                <TableCell className={classes.headerCell}>Status</TableCell>
                <TableCell className={classes.headerCell}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {returnOrderList?.length > 0 ? (returnOrderList?.map((row, index) => (
                <TableRow key={index}>
                  {(userRole == "FSE" || userRole === 'sre') &&
                    <TableCell className={classes.bodyCell1}>
                      <div>{row.createdBy}</div>
                      <div>(SAP ID - {row.sapCustomerId})</div>
                    </TableCell>
                  }
                  <TableCell
                    className={classes.bodyCell}
                    onClick={() => {
                      sessionStorage.setItem("reorder-InoviceDate", row.invoiceDate)
                      sessionStorage.setItem("returnOrderStatus", row.status || "");   // NEW
                      ViewReturnOrderRequest(row.sapCustomerId, row.invoiceNumber, row.returnOrderNo);
                    }}
                    style={{
                      color: "#1A9FE0",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    {row.returnOrderNo}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {moment(row.returnDate).tz('Asia/Dubai').format('YYYY-MM-DD ( HH:mm:ss )')}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    <div>{row.returnRequestBy}</div>
                    {(row?.role === "FSE" || row?.role === "SRE" || sessionStorage.getItem('userType') === 'sre') ?
                      <div className="">{row?.role === "FSE" || row?.role === "SRE" ? "(Al-Futtaim)" : ""}</div>
                      : ""}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.returnLines}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.invoiceNumber}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {moment(row.invoiceDate).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.grossValue ? row.grossValue : '-'}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.totalReturnValue}
                  </TableCell>
                  <TableCell
                    className={classes.bodyCell}
                    style={{ color: getInvoiceColor(row.invoicePeriod) }}
                  >
                    {row.invoicePeriod}
                  </TableCell>
                  <TableCell
                    className={classes.bodyCell}
                    style={{ color: getStatusColor(row.status) }}
                  >
                    {row.status} <IconButton
                      className={classes.actionButton}
                      size="small"
                      onClick={(e) => {
                        setStatusAnchorEl(e.currentTarget);
                        setSelectedTrackingStatus(row.trackingStatus || []);
                      }}
                    >
                      <InfoIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {SHOW_RETURN_FORM_STATUSES.includes(row.status) && (
                      (userRole === 'FSE' || userRole === 'sre') ? (
                        <Tooltip title="View Customer Return form">
                          <IconButton
                            size="small"
                            style={{ color: "#1A9FE0" }}
                            onClick={() => {
                              handleClickPdfViewer();
                              handleViewRetrunOrderForm(row.returnOrderNo, row.invoiceNumber, row.sapCustomerId, row.invoiceDate, row.returnDate)
                            }}
                          >
                            <VisibilityIcon style={{ fontSize: "1.25rem" }} />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="View Customer Return form">
                          <img
                            src={viewReturnIcon}
                            alt="View Customer Return form"
                            style={{ width: 24, height: 24, cursor: "pointer" }}
                            onClick={() => {
                              handleClickPdfViewer();
                              handleViewRetrunOrderForm(row.returnOrderNo, row.invoiceNumber, row.sapCustomerId, row.invoiceDate, row.returnDate)
                            }}
                          />
                        </Tooltip>
                      )
                    )}
                  </TableCell>
                </TableRow>
              ))) : (<TableRow>
                <TableCell
                  colSpan={10}
                  align="center"
                  className={classes.bodyCell}
                >
                  Return Orders are unavailable.
                </TableCell>
              </TableRow>
              )}
              <StatusStepperPopover
                anchorEl={statusAnchorEl}
                trackingStatus={selectedTrackingStatus}
                onClose={() => setStatusAnchorEl(null)}
              />
            </TableBody>
          </Table>
        </TableContainer>
        <div className="col-12 d-flex justify-content-end">
          <TablePagination
            className="pagination"
            rowsPerPageOptions={[rowsPerPage]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
          />
        </div>
      </div>

      {/* PDF Viewer Dialog */}
      <Dialog
        className="full-dialog"
        fullWidth={true}
        maxWidth="md"
        PaperProps={{ style: { height: "80vh" } }}
        open={openPdfViewer}
        aria-labelledby="customized-dialog-title"
        onClose={(event, reason) => {
          setOpenPdfViewer(false);
          setHtmlContent(""); // Clear content when closing
        }}
      >
        <DialogTitle className="pb-0" id="form-dialog-title">
          <div className="page-title">View Return Order Form
            <IconButton aria-label="close" className="float-right" onClick={() => {
              setOpenPdfViewer(false);
              setHtmlContent(""); // Clear content when closing
            }}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers className="p-0">
          {htmlContent ? (
            <iframe
              ref={iframeRef}
              title="Return Order Form"
              srcDoc={htmlContent}
              className={classes.iframeContainer}
              style={{
                width: "100%",
                height: "70vh",
                border: "none",
                backgroundColor: "#fff"
              }}
            />
          ) : (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              padding: '20px'
            }}>
              <p>Loading return order form...</p>
            </div>
          )}
        </DialogContent>
        <DialogActions className="p-3 justify-content-start">
          <div className="float-left">
            <Button
              variant="contained"
              className="submit-button font-size-11 mr-3"
              onClick={handleDownload}
              disabled={!htmlContent}
            >
              Download Form
            </Button>
          </div>
        </DialogActions>
        <DialogActions className="justify-content-end mt-n-65">
          <Button
            variant="contained"
            className="cancel-button font-size-11 mr-3"
            onClick={() => {
              setOpenPdfViewer(false);
              setHtmlContent(""); // Clear content when closing
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}